class FullWidthVideo extends window.BAO.CustomElement() {
  setupListeners () {
    if (!this.els?.video?.exists) return
    super.setupListeners()

    document.addEventListener('click', this.handleTrigger.bind(this))
  }

  handleTrigger (event) {
    if (event.target.closest(this.els.trigger.selector)) {
      this.handleOpen()
    }

    if (event.target.closest(this.els.close.selector)) {
      this.handleClose()
    }
  }

  handleOpen () {
    this.isOpen = true

    if (!this.els.source.element.src) {
      this.els.source.element.src = this.els.source.element.dataset.src
      this.els.video.element.load()
    }
    this.els.video.element.play()
  }

  handleClose () {
    this.isOpen = false
    this.els.video.element.pause()
    document.body.classList.remove('lyt-ModalOpen')
  }

  get isOpen () {
    return this._isOpen
  }

  set isOpen (boolean) {
    this._isOpen = boolean

    this.setAttribute('data-modal-open', String(boolean))
    this.els.modal.element.setAttribute('aria-hidden', String(!boolean))
    document.body.classList.add('lyt-ModalOpen')
  }
}

if (!customElements.get('full-width-video')) {
  customElements.define('full-width-video', FullWidthVideo)
}
